import { Skeleton } from '@mui/material';

const BoatFacilitiesSkeleton = () => {
  return (
    <>
      {[1, 2, 3].map(item => (
        <div
          key={item}
          className="flex py-1 px-3 items-center gap-2 rounded-full bg-neutral-50"
        >
          <Skeleton variant="circular" width={16} height={16} />
          <Skeleton variant="text" width={80} height={20} />
        </div>
      ))}
    </>
  );
};

export default BoatFacilitiesSkeleton;
